import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class TaxRateService {
  private api = inject(ApiService);

  get(isAll: 'all' | '' = '') {
    const path = isAll === 'all' ? '/tax_rate/all' : '/tax_rate/use_to_select';
    return this.api.get(path);
  }
  upsert(json: any) { return this.api.post('/tax_rate', json); }
  remove(id: number) { return this.api.get(`/tax_rate/remove/${id}`); }
}
